<template>
  <div />
</template>
<script>
  // 当 vue 项目部署更新后，如果浏览器端已加载的页面不手动刷新，则会出现某些JS文件丢失，页面功能不正常的现象，
  // 为了及时通知用户刷新页面，本模块会通过轮询的方式检查版本，当版本有更新时，通过页面弹出消息，通知用户刷新页面。
  //
  // 版本判断依据就是 index.html 中，某个 <script> 标签引入的 manifest-xxxxxxxxxx.js，其中的 xxxxxxxxxx 是一个 hash 值，
  // 只要代码修改过，该 hash 值就会改变，只需判断当前文档树中的 manifest-xxxxxxxxxx.js 与
  // 服务器最新 index.html 的 manifest-xxxxxxxxxx.js 是否一致，即可判断页面是否有更新
  // （注意该 <script> 标签在源代码中是不存在的，只有编译后的 index.html 找得到）
  //
  // * 页面打开后就马上检查一次，因为部分浏览器在启动进程加载最近页面时不一定会请求最新页面

  import axios from "axios";

  export default {
    data() {
      return {
        // 用于获取静态文件
        http: axios.create({baseURL: "/"}),
        // 当前已加载页面版本
        version1: null,
        // message 对象
        hMsg: null,
        // timeout 对象
        hTimeout: null,
        // 标记当前模块是否已销毁（异步方法回调时可能已销毁）
        isDestroyed: false,
      };
    },
    mounted() {
      this.version1 = this.getLocalVersion();
      if (null !== this.version1) {
        this.checkPageVersion();
      } else {
        console.warn("获取当前版本失败")
      }
    },
    destroyed() {
      this.isDestroyed = true;
      // 关闭消息框
      if (null !== this.hMsg) {
        this.hMsg.close();
        this.hMsg = null;
      }
      // 取消定时器
      if (null !== this.hTimeout) {
        clearTimeout(this.hTimeout);
        this.hTimeout = null;
      }
    },
    methods: {
      getLocalVersion() {
        if(window.$) {
          // 从当前 DOM 中查找 manifest.xxxxxxxxxx.js
          // 如果是在本地直接运行的，则只有 manifest.js
          let tags = $("script[src^='/static/js/manifest.']");
          for (let tag of tags) {
            let src = $(tag).attr("src");
            if (src.endsWith(".js")) {
              return src;
            }
          }
          return null;
        }
      },
      getNewestVersion() {
        // 从最新的 index.html 文档中查找 manifest.xxxxxxxxxx.js
        // 如果是在本地直接运行的，则只有 manifest.js
        return new Promise((resolve,reject)=>{
          // 加 v 参数只为了获取最新版本而非缓存的版本
          let v = new Date().getTime();
          this.http.get("index.html?v=" + v).then((res)=>{
            let src = this.getNewestSrc(res.data);
            if (null !== src) {
              resolve(src);
            } else {
              reject();
            }
          }).catch(()=>{
            reject();
          });
        });
      },
      getNewestSrc(html) {
        let rg = new RegExp("\\ssrc=\"?(/static/js/manifest\\.\\w+\\.js)");
        let m = rg.exec(html);
        return null !== m ? m[1] : null;
      },
      checkPageVersion() {
        this.hTimeout = null;

        // 定时检查页面版本
        // 加载服务器最新 index.html，判断其中的 manifest.xxxxxxxxxx.js 是否与当前已加载页面的 manifest.xxxxxxxxxx.js 一致
        this.getNewestVersion().then((version2)=>{
          if (!this.isDestroyed) {
            let version1 = this.version1;
            console.log(`ver: b=${version1}, s=${version2}`);
            if (version1 !== version2) {
              // 有新版本页面，提示用户刷新页面
              this.showNotifyUntilRefreshPage();
            } else {
              // 已是最新版本，等待再次检查
              this.hTimeout = setTimeout(this.checkPageVersion, 300000);
            }
          }
        }).catch(()=>{
          if (!this.isDestroyed) {
            // 获取失败了，等待再次检查
            this.hTimeout = setTimeout(this.checkPageVersion, 300000);
          }
        });
      },
      showNotifyUntilRefreshPage() {
        this.hTimeout = null;

        // 在页面顶部弹出消息提示
        this.hMsg = this.$message({
          title: '提示',
          center: true,
          dangerouslyUseHTMLString: true,
          message: '检测到新版本，请刷新页面！<a href="javascript:window.location.reload();">立即刷新</a>',
          // 显示关闭按钮
          showClose: true,
          // 持续时间：0=消息框不自动关闭
          duration: 0,
          // 消息样式
          type: 'warning',
          onClose: ()=>{
            // 用户点击消息框的关闭按钮忽略提示，页面过后会将消息重新弹出，直到用户刷新页面
            this.hTimeout = setTimeout(this.showNotifyUntilRefreshPage, 60000);
          }
        });
      }
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/utility/version-check.vue